import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { Config } from 'src/app/core/configs/config';
import { CloudinaryService } from 'src/app/core/services/cloudinary.service';
import { RouterLink } from '@angular/router';
import { ERoutes } from '../../../core/enums/routes.enum';
import { BreakpointService } from '../../../core/services/breakpoint.service';

@Component({
    selector: 'app-header-banner',
    templateUrl: './header-banner.component.html',
    styleUrls: ['./header-banner.component.scss'],
    imports: [TranslateModule, RouterLink]
})
export class HeaderBannerComponent implements OnInit, OnChanges {
  @Input() public bannerText: string;
  @Input() public bannerDescription: string;
  @Input() public bannerImage: string;
  @Input() public showContent: boolean = true;
  @Input() public localAsset: boolean;
  @Input() public disableBackToPlan: boolean = true;

  public bannerImageUrl = '';

  constructor(
    private cloudinaryService: CloudinaryService,
    protected breakpointService: BreakpointService,
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.bannerImage.currentValue) {
      this.initImage();
    }
  }

  private initImage(): void {
    if (this.localAsset) {
      this.bannerImageUrl = this.cloudinaryService.getCloudImage(
        `${Config.imgCdnUrl}images/` + this.bannerImage,
        true,
      );
      return;
    }

    this.bannerImageUrl = this.cloudinaryService.getCloudImage(
      Config.cdnUrl + this.bannerImage,
      true,
    );
  }

  protected readonly ERoutes = ERoutes;
}
